import SubcategoryPage from '@/components/template/SubcategoryPage';

const Belt = () => {
  const products = [
    {
      title: "Belt Model 1",
      imageSrc: "https://images.unsplash.com/photo-1552454799-ca5cfdc612c8?auto=format&fit=crop&q=80",
      url: "/ogledala/belt/model-1"
    },
    {
      title: "Belt Model 2",
      imageSrc: "https://images.unsplash.com/photo-1616046386594-c152babc9e15?auto=format&fit=crop&q=80",
      url: "/ogledala/belt/model-2"
    },
    {
      title: "Belt Model 3",
      imageSrc: "https://images.unsplash.com/photo-1589798312990-ea8f06163835?auto=format&fit=crop&q=80",
      url: "/ogledala/belt/model-3"
    },
    {
      title: "Belt Model 4",
      imageSrc: "https://images.unsplash.com/photo-1615800001964-5afd02a82171?auto=format&fit=crop&q=80",
      url: "/ogledala/belt/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Belt"
      description="Edinstvena ogledala s pasom, ki omogočajo preprosto obešanje in dodajajo industrijski pridih vašemu domu. Kombinacija praktičnosti in stila."
      heroImage="https://images.unsplash.com/photo-1552454799-ca5cfdc612c8?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default Belt;